import Vue from "vue"
import VueScrollPicker from "vue-scroll-picker"
import ScrollPicker from "vue-scroll-picker"

Vue.use(VueScrollPicker)
Vue.use(ScrollPicker)
